import React, { HTMLInputTypeAttribute } from 'react'
import { FieldError, UseFormRegister, Path, FieldValues } from 'react-hook-form'

interface InputProps<T extends FieldValues> {
  label: string // Nhãn của input
  name: Path<T> // Đảm bảo `name` khớp với các trường trong `T`
  register: UseFormRegister<T> // `register` của `react-hook-form`
  error?: FieldError // Đối tượng lỗi từ `react-hook-form`
  type?: HTMLInputTypeAttribute // Loại input (text, email, password, v.v.)
  placeholder?: string // Placeholder của input
}

const Input = <T extends FieldValues>({
  label,
  name,
  register,
  error,
  type = 'text',
  placeholder,
}: InputProps<T>) => {
  return (
    <div className="mb-4">
      <label className="block mb-1 font-medium">{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        className={`w-full border p-2 rounded ${
          error ? 'border-red-500' : 'border-gray-300'
        } focus:outline-none focus:border-blue-500`}
        {...register(name)}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  )
}

export default Input
